import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import ModalWrapper from 'components/Modals/ModalWrapper';
import UploadWhsDocuments from './UploadWhsDocuments';

class AddWhsDocumentsModal extends Component {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    isAddingDocument: PropTypes.bool,
    onConfirmUpload: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    addingDocumentResults: PropTypes.shape({
      error: PropTypes.shape({
        code: PropTypes.number,
        message: PropTypes.string,
      }),
      success: PropTypes.bool,
      files: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    isSubmittingAddWhsDocuments: PropTypes.bool
  };

  static defaultProps = {
    isAddingDocument: false,
    addingDocumentResults: null,
    isSubmittingAddWhsDocuments: false
  };

  constructor() {
    super();
    this.state = { disableConfirmButton: true, modalSize: 'modal-allow-overflow' };
    this.setDisableConfirm = this.setDisableConfirm.bind(this);
    this.disableConfirm = this.disableConfirm.bind(this);
  }

  onCloseModal(e) {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel(e);
    }
  }

  setDisableConfirm(val) {
    const { disableConfirmButton } = this.state;
    if (disableConfirmButton !== val) {
      this.setState({ disableConfirmButton: val });
    }
  }

  setModalSize(val) {
    this.setState({ modalSize: val });
  }

  disableConfirm() {
    const { isSubmittingAddWhsDocuments } = this.props;

    if (this.state) {
      const { disableConfirmButton } = this.state;
      return disableConfirmButton || isSubmittingAddWhsDocuments;
    }

    return isSubmittingAddWhsDocuments;
  }

  confirmedUpload(uploadedDocs) {
    const { onConfirmUpload, isSubmittingAddWhsDocuments } = this.props;

    // Prevent multiple submissions if a request is already in flight
    if (isSubmittingAddWhsDocuments) {
      return;
    }

    onConfirmUpload(uploadedDocs);
  }

  render() {
    const {
      isShown,
      isAddingDocument,
      addingDocumentResults,
      isSubmittingAddWhsDocuments
    } = this.props;
    const {
      modalSize
    } = this.state;
    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Add Document(s)"
        btnConfirmTitle="Submit"
        btnConfirmClass={ `btn-primary ${ (isAddingDocument || isSubmittingAddWhsDocuments) ? 'loading' : '' }` }
        btnCancelTitle="Close"
        onCancel={ e => this.onCloseModal(e) }
        disableConfirm={ this.disableConfirm }
        modalSize={ modalSize }
        formId="uploadingPdfOrZipDocuments"
        useDummySubmit
        className="add-whs-documents-modal"
        id="add-whs-documents-modal-wrapper"
      >
        <div>
          <UploadWhsDocuments
            id="uploadingDocuments"
            onSubmit={ uploadedDocuments => this.confirmedUpload(uploadedDocuments) }
            onSetModalSize={ val => this.setModalSize(val) }
            results={ addingDocumentResults }
            isSubmitting={ isSubmittingAddWhsDocuments }
            setDisableConfirm={ val => this.setDisableConfirm(val) }
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    auth: {
      permissions
    },
    withholdingStatement: {
      isSubmittingAddWhsDocuments
    }
  } = state;
  return {
    permissions,
    isSubmittingAddWhsDocuments
  };
};

export default connect(
  mapStateToProps
)(AddWhsDocumentsModal);
